module.exports = __webpack_public_path__ + "img/MSB1.7abdfb53.png";